import React from 'react';
import { compose, pure } from 'recompose';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import TwoToggleButton from '../atoms/TwoToggleButton';

const styles = {
  message: {
    whiteSpace: 'pre-wrap'
  }
};

const enhance = compose(pure);

const MessageTableBody = enhance(
  ({
    classes,
    messages,
    emptyRows,
    page,
    rowsPerPage,
    updateOpenConfirm,
    order,
    orderBy
  }) => {
    const sortedResult = _.orderBy(messages, orderBy, order);
    const toggleActionFirst = () => {
      updateOpenConfirm(true);
    };
    const toggleActionSecond = () => {
      updateOpenConfirm(true);
    };
    return (
      <TableBody>
        {sortedResult
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(result => {
            return (
              <TableRow key={result.messageId}>
                <TableCell>{result.messageType}</TableCell>
                <TableCell className={classes.message}>
                  {result.message}
                </TableCell>
                <TableCell>{result.createdAt}</TableCell>
                <TableCell>{result.status}</TableCell>
                <TableCell>
                  <TwoToggleButton
                    value={result.visible}
                    firstValue="VISIBLE"
                    firstLabel="表示"
                    SecondValue="HIDDEN"
                    SecondLabel="非表示"
                    onClickActionFirst={toggleActionFirst}
                    onClickActionSecond={toggleActionSecond}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(MessageTableBody);
